import React, { useState, Fragment } from 'react';
import {
  CardText,
  CardSubtitle,
  Card,
  CardBody,
  CardImg,
  Button,
} from 'reactstrap';
import RoomForm from './RoomForm';
import { RoomImage } from './RoomImage';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { gAPI_RoomDelete_ById } from '../../../../../constants/APIs';
import IntlMessages from '../../../../../helpers/IntlMessages';
export default function RoomCard({ room, propertyId, locale, categoryList }) {
  const {
    name,
    maximumAdults,
    maximumChildren,
    images,
    defaultInventory,
    displayOrder,
    provider,
  } = room;
  const defaultImage = 'https://via.placeholder.com/300/';
  const [visible, setVisible] = useState(false);
  const [visibleImage, setVisibleImage] = useState(false);

  const handleDelete = roomId => {
    const data = { id: roomId, deleter: 'Test' };
    AxiosAPI({
      method: 'delete',
      url: `${gAPI_RoomDelete_ById}/${roomId}`,
      data: data,
    })
      .then(res => {
        setTimeout(() => {
          window.location.reload();
        }, 300);
      })
      .catch(err => {
        console.log('err', err);
      });
  };

  const getRoomData = () => {
    setVisible(!visible);
  };
  const maxoccupancy = maximumAdults + maximumChildren;
  return (
    <Fragment>
      <Card className="mb-4">
        {/* {JSON.stringify(roomData)} */}
        <div className="position-relative">
          {images.length > 0 && (
            <CardImg top src={images[0].url} alt="Card image cap" />
          )}
          {images.length === 0 && (
            <CardImg top src={defaultImage} alt="Card image cap" />
          )}
          {/* <Badge
            color="primary"
            pill
            className="position-absolute badge-top-left"
          >
            NEW
          </Badge>
          <Badge
            color="secondary"
            pill
            className="position-absolute badge-top-left-2"
          >
            TRENDING
          </Badge> */}
        </div>
        <CardBody>
          <CardSubtitle className="mb-4">{name} </CardSubtitle>
          <CardText className="mb-2 font-weight-light">
            <IntlMessages id='dashboards.max-occupancy' /> : {maxoccupancy}, adult: {maximumAdults} , child:{' '}
            {maximumChildren}
          </CardText>
          <CardText className="mb-2 font-weight-light">
            <IntlMessages id='dashboards.numberOfThisType' /> : {defaultInventory}
          </CardText>
          <CardText className="mb-2 font-weight-light">
            <IntlMessages id='dashboards.displayOrder' /> : {displayOrder}
          </CardText>
          <CardText className="mb-2 font-weight-light">
            <IntlMessages id='dashboards.provider' /> : {provider && provider === 'Sabre' ? 'Aven Hospitality' : provider}
          </CardText>
          {/* <CardText className="mb-2 font-weight-light">09.04.2018</CardText> */}

          <Button
            style={{ margin: '2px' }}
            color="primary"
            outline
            size="sm"
            onClick={() => {
              getRoomData();
              //setVisible(!visible);
            }}
          >
            {(provider === 'Sabre' || provider === 'Amadeus') ? 'View' : <IntlMessages id='dashboards.edit' />}
          </Button>
          <Button
            style={{ margin: '2px' }}
            color="danger"
            outline
            size="sm"
            onClick={() => handleDelete(room.id)}
          >
            <IntlMessages id='dashboards.delete' />
          </Button>
          <Button
            color="secondary"
            size="sm"
            style={{ margin: '2px' }}
            outline
            onClick={() => {
              setVisibleImage(!visibleImage);
            }}
          >
            + <IntlMessages id='dashboards.addImages' />
          </Button>
        </CardBody>
      </Card>
      {
        visible === true ? (
          <RoomForm
            roomId={room.id}
            visible={visible}
            toggle={() => {
              setVisible(!visible);
            }}
            propertyId={propertyId}
            locale={locale}
            categoryList={categoryList}
          />
        ) : null
      }
      <RoomImage
        images={room.images}
        visible={visibleImage}
        roomId={room.id}
        toggle={() => {
          setVisibleImage(!visibleImage);
        }}
      />
    </Fragment>
  );
}
